// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.keyring",
    name: "KEYRING PRO",
    homepage: "https://keyring.app/",
    image_id: "dda0f0fb-34e8-4a57-dcea-b008e7d1ff00",
    app: {
        browser: "https://keyring.app/",
        ios: "https://apps.apple.com/us/app/keyring-pro-wallet-management/id1546824976",
        android: "https://play.google.com/store/apps/details?id=co.bacoor.keyring",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "keyring://",
        universal: "https://keyring.app/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map